import { Button, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Trans, useTranslation } from "react-i18next";
import { InteractionStatus } from "@azure/msal-browser";
import { scopes } from "../../authConfig";
import { emailAuth } from "@utils/emailAuthUtils.ts";

export default function Login() {
  const { instance, inProgress } = useMsal();
  const isEmailAuthenticated = !emailAuth.isTokenExpired();
  const isAutheticated = useIsAuthenticated() || isEmailAuthenticated;

  const handleLogin = () => {
    emailAuth.removeJwtToken();
    void instance.loginPopup({ scopes });
  };

  const { t } = useTranslation();

  return (
    <Stack spacing={10} alignItems="center" width="100%">
      <Stack
        spacing={2}
        paddingTop={4}
        alignItems="center"
        textAlign="center"
        maxWidth="500px"
      >
        {!isAutheticated &&
          inProgress !== InteractionStatus.Startup &&
          inProgress !== InteractionStatus.HandleRedirect && (
            <Stack spacing={2} paddingBottom={4}>
              <Typography variant="h5">{t("login")}</Typography>
              <Button
                variant="contained"
                sx={{ px: "5em" }}
                onClick={handleLogin}
              >
                Microsoft Entra
              </Button>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ paddingTop: "1rem" }}
              >
                <Trans i18nKey="loginWithEmail" t={t}>
                  <Link component={RouterLink} to="/invitation/login">
                    {t("userDetailsPage.purchaseParkingPermit")}
                  </Link>
                </Trans>
              </Typography>
            </Stack>
          )}
      </Stack>
    </Stack>
  );
}
